var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AppConfigService, AppService } from '@aperza/util';
import PropTypes from 'prop-types';
import React from 'react';
import { source } from 'react-aim';
import CategoryItem2List from './CategoryItem2List';
const appConfig = AppService.appConfig();
// @ts-ignore
let CategoryItem1 = class CategoryItem1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { over: false };
    }
    onClick() {
        let { name, displayCategoryId } = this.props.productCategory;
        if (!this.props.disableMarketplaceBanner) {
            window.location.href = `${appConfig.marketplaceWebHost}/${appConfig.langCode}/s/item/?rf=1108&fc=%7C${displayCategoryId}&k=`;
        }
        else if (AppConfigService.shouldShowMarketplaceTopBanner()) {
            window.location.href = `${appConfig.searchWebHost}/${appConfig.langCode}/s/item/?rf=1108&fc=%7C${displayCategoryId}&k=`;
        }
        else {
            window.location.href = `${appConfig.searchWebHost}/${appConfig.langCode}/c/1/${encodeURIComponent(name)}/${displayCategoryId}/index.html`;
        }
    }
    render() {
        let { name, displayCategoryId, itemCount } = this.props.productCategory;
        let { over } = this.state;
        let nameStyle = {};
        let layer2 = undefined;
        if (over) {
            layer2 = (React.createElement(CategoryItem2List, { productCategory: this.props.productCategory, disableMarketplaceBanner: this.props.disableMarketplaceBanner }));
            nameStyle = { color: '#e60032', textDecoration: 'underline' };
        }
        let imageUrl = `/common/images/category/${displayCategoryId}.png`;
        imageUrl = AppService.staticUrl(imageUrl);
        return (React.createElement("div", { className: "categoryItemContainer" },
            React.createElement("a", { className: "categoryItem" },
                React.createElement("img", { src: imageUrl }),
                React.createElement("p", { className: "name", onClick: this.onClick.bind(this) },
                    React.createElement("span", { style: nameStyle }, name),
                    itemCount && React.createElement("span", { className: "number" },
                        "(",
                        itemCount.toLocaleString('en'),
                        ")")),
                React.createElement("i", { className: "fa fa-chevron-right", "aria-hidden": "true" })),
            layer2));
    }
};
CategoryItem1.propTypes = {
    productCategory: PropTypes.shape({
        name: PropTypes.string.isRequired,
        displayCategoryId: PropTypes.number.isRequired,
        itemCount: PropTypes.number.isRequired,
        disableMarketplaceBanner: PropTypes.bool,
    }).isRequired,
};
CategoryItem1 = __decorate([
    source({
        mouseEnter: (props, component) => {
            // @ts-ignore
            return component.setState({ over: true });
        },
        mouseLeave: (props, component) => {
            // @ts-ignore
            return component.setState({ over: false });
        },
    }),
    __metadata("design:paramtypes", [Object])
], CategoryItem1);
export default CategoryItem1;
